import { verifyContainerType } from '../utils/Decorator';
import { ContainerType, OperateDocumentEnum } from '../common/Constant';
import log from 'loglevel';
/**
 *
 *
 * @export
 * @class DocApi
 */
export default class DocApi {
  constructor(container, store) {
    this.container = container;
    this.store = store;
  }

  /**
   * 设置文档根据文档的Hash进行设置， 文档的基础领再创建的时候 由opts 传入
   *
   * @param {*} hash
   * @param {object} opts
   * @param {bool} isRemote
   * @memberof DocModuler
   */
  @verifyContainerType(ContainerType.DOCUMENT)
  setDoc(hash, opts = {}, isRemote) {
    if (hash === '') {
      log.warn('empty hash');
      return;
    }

    this.container.operateDocument(OperateDocumentEnum.SetDoc, hash, opts, isRemote);
  }

  /**
   * 移除当前文档
   *
   * @memberof DocModuler
   */
  @verifyContainerType(ContainerType.DOCUMENT)
  removeDoc() {
    this.container.operateDocument(OperateDocumentEnum.RemoveDocument);
  }

  /**
   * 下一页
   * @memberof DocModuler
   */
  @verifyContainerType(ContainerType.DOCUMENT)
  nextPage() {
    const { userId } = this.store.getKV('passThrough');
    this.store.setKV('sender', userId);
    this.container.operateDocument(OperateDocumentEnum.NextPage);
  }

  /**
   * 上一页
   *
   * @memberof DocModuler
   */
  @verifyContainerType(ContainerType.DOCUMENT)
  prevPage() {
    const { userId } = this.store.getKV('passThrough');
    this.store.setKV('sender', userId);
    this.container.operateDocument(OperateDocumentEnum.PreviousPage);
  }

  /**
   * 跳转到某一页
   *
   * @param {*} id
   * @memberof DocModuler
   */
  @verifyContainerType(ContainerType.DOCUMENT)
  gotoPage(id) {
    const { userId } = this.store.getKV('passThrough');
    this.store.setKV('sender', userId);
    this.container.operateDocument(OperateDocumentEnum.GotoPage, id);
  }

  /**
   *下一步
   *
   * @memberof DocModuler
   */
  @verifyContainerType(ContainerType.DOCUMENT)
  nextStep() {
    const { userId } = this.store.getKV('passThrough');
    this.store.setKV('sender', userId);
    this.container.operateDocument(OperateDocumentEnum.NextStep);
  }

  /**
   * 上一步
   *
   * @memberof DocModuler
   */
  @verifyContainerType(ContainerType.DOCUMENT)
  prevStep() {
    const { userId } = this.store.getKV('passThrough');
    this.store.setKV('sender', userId);
    this.container.operateDocument(OperateDocumentEnum.PreviousStep);
  }

  /**
   *跳转到某一步
   *
   * @param {*} pageId
   * @param {*} stepId
   * @memberof DocModuler
   */
  @verifyContainerType(ContainerType.DOCUMENT)
  gotoStep(pageId, stepId) {
    const { userId } = this.store.getKV('passThrough');
    this.store.setKV('sender', userId);
    this.container.operateDocument(OperateDocumentEnum.GotoStep, pageId, stepId);
  }

  /**
   * 获取文档缩略图列表
   *
   * @returns
   * @memberof DocModuler
   */
  @verifyContainerType(ContainerType.DOCUMENT)
  getThumbnailList() {
    return this.container.getThumbnailList();
  }

  /**
   * 获取文档基础信息
   *
   * @memberof DocApi
   * @returns 文档信息
   */
  @verifyContainerType(ContainerType.DOCUMENT)
  getDocInfo() {
    let { doc } = this.container.pageInfo;
    return doc;
  }
}
